import {
  HIS_ACCOUNTANT,
  HIS_ADMIN,
  HIS_BRANCH_MANAGER,
  HIS_CASHIER,
  HIS_CHIEF_TECHNICIAN,
  HIS_DOCTOR,
  HIS_READ_ONLY,
  HIS_SALES_CONSULTANT,
  HIS_SUPER_ADMIN,
  HIS_TECHNICIAN,
  PathModule,
} from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const PatientManagementRoute = {
  path: PathModule.PATIENT_MANAGEMENT,
  exact: true,
  auth: [
    HIS_ADMIN,
    HIS_SALES_CONSULTANT,
    HIS_BRANCH_MANAGER,
    HIS_CASHIER,
    HIS_DOCTOR,
    HIS_CHIEF_TECHNICIAN,
    HIS_TECHNICIAN,
    HIS_READ_ONLY,
  ],

  children: [
    {
      path: "patient-list",
      auth: [
        HIS_ADMIN,
        HIS_SALES_CONSULTANT,
        HIS_BRANCH_MANAGER,
        HIS_CASHIER,
        HIS_READ_ONLY,
      ],

      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/PatientList/PatientListIndex"),
      }),
    },
    {
      path: "check-in-list",
      auth: [
        HIS_ADMIN,
        HIS_SALES_CONSULTANT,
        HIS_BRANCH_MANAGER,
        HIS_DOCTOR,
        HIS_CASHIER,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/CheckInList/CheckInListIndex"),
      }),
    },
    {
      path: "patient-general",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/PatientGeneral/PatientGeneralIndex"),
      }),
      auth: [
        HIS_ADMIN,
        HIS_SALES_CONSULTANT,
        HIS_BRANCH_MANAGER,
        HIS_CASHIER,
        HIS_DOCTOR,
        HIS_READ_ONLY,
        HIS_CHIEF_TECHNICIAN,
        HIS_TECHNICIAN,
      ],
    },
    {
      path: "appointment-tracking",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/AppointmentTracking/AppointmentTrackingIndex"
          ),
      }),
      auth: [
        HIS_ADMIN,
        HIS_SALES_CONSULTANT,
        HIS_BRANCH_MANAGER,
        HIS_READ_ONLY,
      ],
    },

    {
      path: "appointment-list",
      auth: [
        HIS_ADMIN,
        HIS_SALES_CONSULTANT,
        HIS_BRANCH_MANAGER,
        HIS_CASHIER,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/AppointmentList/AppointmentListIndex"),
      }),
    },

    {
      path: "treament-plan-card-list",
      auth: [HIS_ADMIN, HIS_SUPER_ADMIN, HIS_BRANCH_MANAGER, HIS_READ_ONLY],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/TreatmentPlanList/TreatmentPlanListIndex"
          ),
      }),
    },
    {
      path: "prepaid-card-usage",
      auth: [
        HIS_ADMIN,
        HIS_SUPER_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_CASHIER,
        HIS_SALES_CONSULTANT,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/TreatmentPlanCard/TreatmentPlanCardIndex"
          ),
      }),
    },
    {
      path: "reward-point",
      auth: [HIS_ADMIN, HIS_SUPER_ADMIN, HIS_BRANCH_MANAGER, HIS_READ_ONLY],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/RewardPointList/RewardPointListIndex"),
      }),
    },
    {
      path: "report-by-payment-method",
      // auth: [
      //   HIS_SUPER_ADMIN,
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CASHIER,
      //   HIS_READ_ONLY,
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportPayment/ReportPaymentIndex"),
      }),
    },
    {
      path: "report-get-revenue-detail",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueDetail/ReportRevenueDetailIndex"
          ),
      }),
    },
    {
      path: "report-get-group-service",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueGroupService/ReportRevenueGroupServiceIndex"
          ),
      }),
    },
    {
      path: "report-employee-revenue-allocation-summary",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportEmployeeRevenueAllocationSummary/ReportOverview/ReportOverviewIndex"
          ),
      }),
    },
    {
      path: "report-expense",
      // auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportExpense/ReportExpenseIndex"),
      }),
    },

    {
      path: "report-sales-allocation",
      // auth: [
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CHIEF_TECHNICIAN,
      //   HIS_TECHNICIAN,
      //   HIS_CASHIER,
      //   HIS_READ_ONLY,
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationIndex"
          ),
      }),
    },
    {
      path: "report-revenue-allocation",
      // auth: [
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CHIEF_TECHNICIAN,
      //   HIS_TECHNICIAN,
      //   HIS_CASHIER,
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueAllocation/ReportRevenueAllocationIndex"
          ),
      }),
    },
    {
      path: "report-debt",
      // auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportDebt/ReportDebtIndex"),
      }),
    },
    {
      path: "voucher-item-report",
      // auth: [
      //   HIS_ADMIN,
      //   HIS_SUPER_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CASHIER,
      //   HIS_ACCOUNTANT,
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/VoucherItemReport/VoucherItemReportIndex"
          ),
      }),
    },
    {
      path: "patient-duplicate-phone",
      auth: [
        HIS_ADMIN,
        HIS_SUPER_ADMIN,
        HIS_BRANCH_MANAGER,
        HIS_SALES_CONSULTANT,
        HIS_CASHIER,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/PatientDuplicatePhone/PatientDuplicatePhoneIndex"
          ),
      }),
    },
    {
      path: "voucher-list",
      auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_READ_ONLY],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/VoucherList/VoucherListIndex"),
      }),
    },
    {
      path: "report-checkin",
      // auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportCheckin/ReportCheckinIndex"),
      }),
    },
    {
      path: "treatment-report",
      // auth: [
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CHIEF_TECHNICIAN,
      //   HIS_SUPER_ADMIN,
      //   HIS_DOCTOR,
      //   HIS_SALES_CONSULTANT,
      //   HIS_TECHNICIAN,
      //   HIS_CASHIER,
      //   HIS_READ_ONLY,
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/TreatmentReport/TreatmentReportIndex"
          ),
      }),
    },
    {
      path: "sales-report",
      // auth: [
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CHIEF_TECHNICIAN,
      //   HIS_TECHNICIAN,
      //   HIS_CASHIER,
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportSales/ReportSalesIndex"),
      }),
    },
    {
      path: "revenue-details-report",
      // auth: [
      //   HIS_ADMIN,
      //   HIS_BRANCH_MANAGER,
      //   HIS_CHIEF_TECHNICIAN,
      //   HIS_TECHNICIAN,
      //   HIS_CASHIER,
      // ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRevenueDetails/ReportRevenueDetailsIndex"
          ),
      }),
    },
    {
      path: "booking-exam",
      auth: [
        HIS_ADMIN,
        HIS_SALES_CONSULTANT,
        HIS_BRANCH_MANAGER,
        HIS_DOCTOR,
        HIS_CASHIER,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/CheckInList/CheckInListIndex"),
      }),
    },
    {
      path: "revenue-register-service",
      auth: [
        HIS_SUPER_ADMIN,
        HIS_ADMIN,
        HIS_CASHIER,
        HIS_ACCOUNTANT,
        HIS_BRANCH_MANAGER,
        HIS_READ_ONLY,
      ],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRegisterService/ReportRegisterServiceindex"
          ),
      }),
    },
    {
      path: "revenue-register-product",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRegisterDrug/ReportRegisterDrugIndex"
          ),
      }),
    },
    {
      path: "revenue-register-card",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportRegisterCard/ReportRegisterCardIndex"
          ),
      }),
    },
    {
      path: "report-order-summary",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportInvoiceSummary/ReportInvoiceSummaryIndex"
          ),
      }),
    },
    {
      path: "invoice-cancellation-report",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportCancelInvoice/ReportCancelInvoiceIndex"
          ),
      }),
    },
    {
      path: "price-item-report",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportPriceItem/ReportPriceItemIndex"),
      }),
    },

    {
      path: "invoice-item-debt",
      auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],

      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/ReportInvoiceDebt/ReportInvoiceDebtIndex"
          ),
      }),
    },
    {
      path: "construction-materials-synthesis",
      auth: [HIS_ADMIN, HIS_CASHIER],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/ConstructionMaterialsSynthesis/ConstructionMaterialsSynthesisIndex"
          ),
      }),
    },
    {
      path: "construction-materials-synthesis",
      auth: [HIS_ADMIN, HIS_CASHIER],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/TreatmentManagement/ConstructionMaterialsSynthesis/ConstructionMaterialsSynthesisIndex"
          ),
      }),
    },
    {
      path: "deduction-report",
      auth: [HIS_ADMIN, HIS_BRANCH_MANAGER, HIS_CASHIER, HIS_ACCOUNTANT],
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import("app/PatientManagement/ReportDeduction/ReportDeductionIndex"),
      }),
    },
    {
      path: "embedded-iframe",
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/EmbeddedIFrame/EmbeddedIFrameIndex"),
      }),
    },
  ],
};
export default PatientManagementRoute;
